"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const subscribable_1 = __importDefault(require("./subscribable"));
class RequestSecret extends subscribable_1.default {
    constructor(dataService, initParams) {
        super(dataService, initParams.id);
        this.objectTypeName = 'requestSecret';
        this._applicationId = initParams.application_id;
        this._password = initParams.password;
        this._clientSecret = initParams.client_secret;
    }
    set applicationId(value) {
        console.error('Do not set objects this way');
    }
    get applicationId() {
        return this._applicationId;
    }
    set password(value) {
        console.error('Do not set objects this way');
    }
    get password() {
        return this._password;
    }
    set clientSecret(value) {
        console.error('Do not set objects this way');
    }
    get clientSecret() {
        return this._clientSecret;
    }
}
exports.default = RequestSecret;
//# sourceMappingURL=requestSecret.js.map